import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { ISubscriptionView } from '../../interfaces/ISubscriptionView';

interface SearchSubscriptionsAlgoliaResponse {
  hits: ISubscriptionView[];
  nbHits: number;
  page: number;
}

async function searchSubscriptions(
  auth: Authentication | null,
  query: string,
  page = 0,
  hitsPerPage = 20,
  filters?: Record<string, unknown>,
): Promise<SearchSubscriptionsAlgoliaResponse> {
  try {
    if (!auth) throw new SearchSubscriptionsAlgoliaFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const params = new URLSearchParams({
      q: query,
      page: String(page),
      hitsPerPage: String(hitsPerPage),
    });

    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;
        if (Array.isArray(value)) {
          value.forEach((v: string) => params.append(`${key}[]`, v));
        } else {
          params.append(key, String(value));
        }
      });
    }

    const json = await HttpClient.get(
      `/algolia/search/backoffice/subscriptions?${params.toString()}`,
      auth.token
    );

    return { hits: json.hits, nbHits: json.nbHits, page };
  } catch (e) {
    if (e instanceof SearchSubscriptionsAlgoliaFailure) throw e;
    throw new SearchSubscriptionsAlgoliaFailure();
  }
}

export class SearchSubscriptionsAlgoliaFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default searchSubscriptions;
